import React from 'react';
import '../styles/footer.css';
export const Footer = () => {
    return (
        <div className="Footer">
            <a href={'https://www.raulacostadeveloper.com/dev'} target="_blank">Raul Acosta Front End Developer 2024</a>
        </div>
    )
}